'use client';

import {
    TooltipArrow,
    TooltipContentProps,
    TooltipPortal,
    TooltipProps,
    TooltipTriggerProps,
} from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';
import React, { PropsWithChildren, ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

export type CustomTooltipProps = PropsWithChildren<{
    title: ReactNode;
    tooltipProps?: TooltipProps;
    tooltipTriggerProps?: TooltipTriggerProps;
    tooltipContentProps?: TooltipContentProps;

    container?: HTMLElement | null;
}>;

const CustomTooltip = ({
    title,
    children,
    tooltipContentProps,
    tooltipProps,
    tooltipTriggerProps,
    container,
}: CustomTooltipProps) => {
    return (
        <Tooltip delayDuration={500} {...tooltipProps}>
            <TooltipTrigger asChild {...tooltipTriggerProps}>
                {children}
            </TooltipTrigger>
            {!!container ? (
                <TooltipPortal container={container}>
                    <TooltipContent {...tooltipContentProps}>
                        <TooltipArrow className='fill-background' />

                        {title}
                    </TooltipContent>
                </TooltipPortal>
            ) : (
                <TooltipContent {...tooltipContentProps}>
                    <TooltipArrow className='fill-background' />
                    {title}
                </TooltipContent>
            )}
        </Tooltip>
    );
};

const CustomTooltipInfoIcon = ({
    children,
    icon,
    tooltipProps,
    ...rest
}: React.PropsWithChildren<
    CustomTooltipProps & {
        icon?: ReactNode;
    }
>) => {
    return (
        <div className='flex items-center gap-2'>
            {children}
            <CustomTooltip
                tooltipProps={{ delayDuration: 100, ...tooltipProps }}
                {...rest}
            >
                {icon ?? <Info className='cursor-pointer' size={15} />}
            </CustomTooltip>
        </div>
    );
};

export { CustomTooltip, CustomTooltipInfoIcon };
